const muscleGroups: Record<string, any> = {
  abs: require("./abs.jpg"),
  arms: require("./arms.jpg"),
  back: require("./back.jpg"),
  chest: require("./chest.jpg"),
  glutes: require("./glutes.jpg"),
  legs: require("./legs.jpg"),
  shoulders: require("./shoulders.jpg"),
  triceps: require("./triceps.jpg"),
};

export default muscleGroups;
